<h2 mat-dialog-title>Crop Profile Image</h2>

<mat-dialog-content>
    <div class="image-cropper-container">
        <div class="cropper-area">
            <canvas #sourceCanvas (mousedown)="onMouseDown($event)" (mousemove)="onMouseMove($event)"
                (mouseup)="onMouseUp()" (mouseleave)="onMouseLeave()">
            </canvas>

        </div>

        <div class="preview-area">
            <div class="preview-container">
                <canvas #previewCanvas width="120" height="120"></canvas>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button (click)="cancel()">Cancel</button>
    <span class="spacer"></span>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="!hasCroppedImage()">Save</button>
</mat-dialog-actions>